import React, { useState, useEffect } from 'react';
import './NotificationPopup.css';

const NotificationPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Notification data
  const notifications = [
    {
      id: 1,
      title: "NIELIT Courses",
      description: "Free courses available for OBC category students",
      link: "/nielit",
      colorClass: "blue"
    },
    {
      id: 2,
      title: "UPSDM Project",
      description: "Skill development program - Free for OBC",
      link: "/upsdm",
      colorClass: "green"
    },
    {
      id: 3,
      title: "BSDM Initiative",
      description: "Bihar Skill Development Mission - Free admission",
      link: "/bsdm",
      colorClass: "purple"
    },
    {
      id: 4,
      title: "ASDC Program",
      description: "Automotive Skills Development Council - OBC Free",
      link: "/asdc",
      colorClass: "orange"
    },
    {
      id: 5,
      title: "PMKVY Scheme",
      description: "Pradhan Mantri Kaushal Vikas Yojana - Free Training",
      link: "/pmkvy",
      colorClass: "red"
    }
  ];

  // Auto open popup after 1 second
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (!isOpen) return null;

  return (
    <div className="notification-overlay">
      <div className="notification-popup">
        {/* Header */}
        <div className="notification-header">
          <div className="notification-header-content">
            <span className="notification-icon">🔔</span>
            <h2 className="notification-title">Latest Updates</h2>
          </div>
          <button
            onClick={() => setIsOpen(false)}
            className="close-button"
          >
            ×
          </button>
        </div>

        {/* Scrolling Notifications Container */}
        <div className="notification-scroll-container">
          <div className="notification-scroll-content">
            {/* Duplicate notifications for seamless loop */}
            {[...notifications, ...notifications].map((notif, index) => (
              <a
                key={`${notif.id}-${index}`}
                href={notif.link}
                className="notification-card"
              >
                <div className="notification-card-inner">
                  <div className={`notification-card-accent ${notif.colorClass}`}></div>
                  <div className="notification-card-content">
                    <h3 className="notification-card-title">
                      {notif.title}
                    </h3>
                    <p className="notification-card-description">
                      {notif.description}
                    </p>
                    <span className="notification-card-link">
                      View Details →
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="notification-footer">
          <p className="notification-footer-text">
            🎓 Free courses for OBC students | Limited seats available
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotificationPopup;